export default [
  {
    action: `read`,
    subject: `clientsub`,
  },
  {
    action: `read`,
    subject: `client-dashboard`,
  },
];
